import { loadStripe } from "@stripe/stripe-js";

export const getStripePublishableKey = () => {
  const env = (process.env.REACT_APP_IS_PROD || "").toUpperCase();
  if (env === "TRUE" || env === "PROD") {
    return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD || "";
  }
  return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST || "";
};

export const stripePromise = loadStripe(getStripePublishableKey()).catch((err) => {
  console.error("Stripe load error:", err);
  return null;
});
